import "./instrument.js";
import { initializeConfiguration } from "@holisto-web/config";
import { http } from "msw";
import { checkoutHandlers } from "@test-utils/api";

const appConfiguration = window.CONFIGURATION;
initializeConfiguration(appConfiguration);

if (process.env.REACT_APP_WITH_MSW === "true") {
  const { mswWorker } = await import("../msw/msw-worker.js");
  const { handlers: versionCheckerHandlers } = await import("@test-utils/version-checker/msw-handlers");
  const { utils } = await import("@test-utils/hotels/api");
  const { createClientFeatureFlagHandlers } = await import("@test-utils/feature-flags");
  await mswWorker.start({ onUnhandledRequest: "bypass" });

  window.msw = {
    mswWorker,
    http,
    handlers: {
      ...versionCheckerHandlers,
      ...checkoutHandlers,
    },
    utils: { ...utils, createFeatureFlagHandlers: createClientFeatureFlagHandlers },
    ready: false,
  };
}

window.appVersion = process.env.REACT_APP_VERSION || "local";
window.dataLayer.push({ appVersion: process.env.REACT_APP_VERSION || "local" });

await import("./index.js");
